var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhgicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43238 19.123L3.65845 18.1755",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_596_43885",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_596_43885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53291 23.5273L8.75179 21.6438C8.49458 21.0235 8.03019 20.5115 7.43788 20.1952L6.62671 19.7619",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4513 14.7031C12.9755 14.6458 12.4911 14.6164 11.9999 14.6164C11.5333 14.6164 11.0731 14.643 10.6204 14.6947",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0477 17.707C18.8485 16.626 17.4306 15.7829 15.8682 15.2524",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54232 15.1207C4.83764 16.2311 1.88447 19.08 0.629816 22.7199C0.473019 23.1749 0.814879 23.6484 1.2961 23.6484H22.7037C23.1849 23.6484 23.5268 23.1749 23.37 22.7199C22.8641 21.2524 22.0822 19.9134 21.0863 18.7652",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.969 14.7362C11.6303 15.3168 11.4852 15.8974 11.5819 16.5749C11.7271 17.4941 12.1626 18.3167 12.7432 19.0425C13.1786 19.5263 13.7109 19.865 14.3399 19.9618C16.0334 20.1553 17.6784 20.1553 19.3235 20.2521C19.6622 20.3005 20.0009 20.3488 20.2912 20.4456C20.5815 20.5908 20.8718 20.7359 21.1138 20.9295L23.2038 23.0195",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70417 5.759C9.35884 5.5257 8.94254 5.38948 8.49447 5.38948C7.29953 5.38948 6.33081 6.35816 6.33081 7.55309C6.33081 8.74812 7.29953 9.7168 8.49447 9.7168C8.97976 9.7168 9.37895 9.557 9.6819 9.28719C9.74462 9.23131 9.80317 9.1708 9.85754 9.10597",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3297 7.55314C15.3297 8.74812 14.361 9.7168 13.1661 9.7168C11.9711 9.7168 11.0024 8.74812 11.0024 7.55314C11.0024 6.3582 11.9711 5.38953 13.1661 5.38953C14.361 5.38953 15.3297 6.3582 15.3297 7.55314Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6692 9.71177C17.6692 9.71177 16.6112 9.72508 16.561 9.70839C16.5109 9.69166 16.6414 9.60339 17.3351 8.61227C17.4647 8.42716 17.536 8.27102 17.5663 8.14019L17.5771 8.05605C17.5771 7.74874 17.3279 7.49959 17.0206 7.49959C16.7502 7.49959 16.5248 7.69249 16.4746 7.94819",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70623 5.98655C2.03095 6.83011 1.62708 7.9004 1.62708 9.06501C1.62708 9.85162 1.81167 10.595 2.13937 11.2548C1.07152 11.8665 0.351562 13.0165 0.351562 14.3353C0.351562 14.6255 0.386484 14.9074 0.452344 15.1773C0.583266 15.7141 1.26056 15.8847 1.64306 15.486C4.24533 12.7736 7.90655 11.085 11.9622 11.085C13.4869 11.085 14.9558 11.3236 16.3335 11.7657",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6694 12.2685C19.3716 13.0104 20.9013 14.0742 22.1818 15.3827C22.5344 15.7431 23.1419 15.6247 23.3333 15.1582C23.5365 14.6632 23.6486 14.121 23.6486 13.5526C23.6486 11.902 22.7037 10.4722 21.3254 9.77404C21.5323 9.34575 21.6484 8.86528 21.6484 8.35776C21.6484 6.72164 20.4432 5.36723 18.8721 5.13323C18.1664 2.38565 15.673 0.355121 12.7052 0.355121C10.1061 0.355121 7.87109 1.91268 6.8818 4.14515C6.77436 4.13817 6.66608 4.13423 6.55686 4.13423C5.53508 4.13423 4.58595 4.44506 3.79883 4.97732",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.52 14.1979L9.47206 13.123C9.33406 12.9815 9.10657 12.9815 8.96857 13.123L7.92059 14.1979C7.70346 14.4207 7.86129 14.7949 8.17235 14.7949H8.48942C8.77067 15.123 8.86442 15.498 8.81754 15.9199C8.72379 16.3887 8.44254 16.7168 8.30192 17.1855C8.18168 17.6664 8.23278 18.1815 8.39651 18.643C8.44578 18.7819 8.57923 18.873 8.72651 18.873H9.3237C9.56585 18.873 9.73713 18.6333 9.65529 18.4054C9.60026 18.2523 9.56754 18.0939 9.56754 17.9355C9.61442 17.4199 9.98942 16.998 10.13 16.4824C10.2707 15.9199 10.2238 15.3105 9.89567 14.7949H10.2682C10.5793 14.7949 10.7371 14.4207 10.52 14.1979Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1096 14.1979L15.0617 13.123C14.9237 12.9815 14.6961 12.9815 14.5582 13.123L13.5102 14.1979C13.2931 14.4207 13.4509 14.7949 13.762 14.7949H14.079C14.3603 15.123 14.454 15.498 14.4071 15.9199C14.3134 16.3887 14.0321 16.7168 13.8915 17.1855C13.7713 17.6664 13.8223 18.1815 13.9861 18.643C14.0354 18.7819 14.1688 18.873 14.3161 18.873H14.9133C15.1555 18.873 15.3267 18.6333 15.2449 18.4054C15.1899 18.2523 15.1571 18.0939 15.1571 17.9355C15.204 17.4199 15.579 16.998 15.7196 16.4824C15.8603 15.9199 15.8134 15.3105 15.4853 14.7949H15.8578C16.1689 14.7949 16.3267 14.4207 16.1096 14.1979Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhgicon);
export default __webpack_public_path__ + "static/media/ghgicon.86195ab5f3f878a76f4facb40693982e.svg";
export { ForwardRef as ReactComponent };